export default __webpack_public_path__ + "static/media/invite-icon.47b20ace.svg";